import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chip", "input", "hidden"]

  connect() {
    this.sync()
  }

  remove(event) {
    event.preventDefault()
    const chip = event.currentTarget.closest("[data-job-title-chips-target='chip']")
    chip.remove()
    this.sync()
  }

  keydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.addFromInput()
    }
  }

  blur() {
    this.addFromInput()
  }

  addFromInput() {
    const value = this.inputTarget.value.trim().replace(/,$/, "")
    if (!value) return

    const existing = this.currentTitles()
    if (existing.map(t => t.toLowerCase()).includes(value.toLowerCase())) {
      this.inputTarget.value = ""
      return
    }

    const chip = this.buildChip(value)
    this.inputTarget.insertAdjacentElement("beforebegin", chip)
    this.inputTarget.value = ""
    this.sync()
  }

  buildChip(title) {
    const span = document.createElement("span")
    span.setAttribute("data-job-title-chips-target", "chip")
    span.setAttribute("data-title", title)
    span.className = "inline-flex items-center gap-1 pl-2.5 pr-1.5 py-0.5 rounded-full text-xs font-medium bg-white border border-indigo-200 text-indigo-700"
    span.innerHTML = `
      ${this.escapeHtml(title)}
      <button type="button"
              data-action="click->job-title-chips#remove"
              class="flex-shrink-0 w-3.5 h-3.5 rounded-full text-indigo-400 hover:text-indigo-700 hover:bg-indigo-100 flex items-center justify-center transition-colors"
              aria-label="Remove">
        <svg viewBox="0 0 12 12" fill="currentColor" class="w-2.5 h-2.5">
          <path d="M6 4.586L9.293 1.293a1 1 0 111.414 1.414L7.414 6l3.293 3.293a1 1 0 01-1.414 1.414L6 7.414l-3.293 3.293a1 1 0 01-1.414-1.414L4.586 6 1.293 2.707A1 1 0 012.707 1.293L6 4.586z"/>
        </svg>
      </button>
    `
    return span
  }

  currentTitles() {
    return this.chipTargets.map(chip => chip.dataset.title).filter(Boolean)
  }

  sync() {
    this.hiddenTarget.value = this.currentTitles().join(",")
  }

  escapeHtml(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
  }
}
